<div class="log-container">
  <textarea class="log-textarea" [rows]="height" [value]="value" readonly></textarea>
  <ng-content></ng-content>
</div>
